import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IAPIResponseFile, IUploadResponse } from "../../models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  constructor(private http: HttpClient) {}

  getFiles = (): Observable<IAPIResponseFile[]> => {
    return this.http.get(
      `${environment.apiUrl}/getUploadedFiles`
    ) as Observable<IAPIResponseFile[]>;
  };

  uploadFiles = (formData): Observable<IUploadResponse> => {
    return this.http.post(
      `${environment.apiUrl}/uploadIwaFiles`,
      formData
    ) as Observable<IUploadResponse>;
  };
}
